import { createClassNames } from '@dtvgo/classnames';

export const ClassNames = createClassNames('dtv-html5');
